"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.new.title': 'Añadir Nuevo Conocimiento',
    'shortcuts.new.description': 'Crea o añade nuevo conocimiento al sistema',
};
